import GraphQLIntrospectionResult from 'graphql-client/schema/GraphQLIntrospectionResult';
import {IntrospectionAbstractType, typeIsAbstract} from 'graphql-client/schema/util/SchemaOps';
import lazyInit from 'util/lazyInit';

interface ConcreteTypeToSatisfiedTypes {
  [concreteType: string]: Set<string>;
}

export interface TypenameToPossibleTypes {
  [typename: string]: Array<string>;
}

export class PossibleTypesMapping {
  private concreteTypeToSatisfiedTypes: ConcreteTypeToSatisfiedTypes;

  constructor(concreteTypeToSatisfiedTypes: ConcreteTypeToSatisfiedTypes) {
    this.concreteTypeToSatisfiedTypes = concreteTypeToSatisfiedTypes;
  }

  public static create(typenameToPossibleTypes: TypenameToPossibleTypes): PossibleTypesMapping {
    const concreteTypeToSatisfiedTypes: ConcreteTypeToSatisfiedTypes = {};
    for (const [typename, possibleTypes] of Object.entries(typenameToPossibleTypes)) {
      for (const concreteType of possibleTypes) {
        if (!concreteTypeToSatisfiedTypes[concreteType]) {
          concreteTypeToSatisfiedTypes[concreteType] = new Set();
        }
        concreteTypeToSatisfiedTypes[concreteType].add(typename);
      }
    }
    return new PossibleTypesMapping(concreteTypeToSatisfiedTypes);
  }

  /**
   * Returns whether the given concrete type satisfies the typename
   *
   * Examples:
   *     concrete_type="LocationNode", typename="LocationNode" => True
   *     concrete_type="LocationNode", typename="BoxNode" => False
   *     concrete_type="LocationNode", typename="StorableInterface" => True
   *     concrete_type="LocationNode", typename="StorableOrInaccessibleInfoNode" => True
   */
  public concreteTypeSatisfiesType(concreteType: string, typename: string): boolean {
    return concreteType === typename || this.concreteTypeToSatisfiedTypes[concreteType].has(typename);
  }
}

export function getTypenameToPossibleTypesFromSchema(): TypenameToPossibleTypes {
  const abstractTypes = GraphQLIntrospectionResult.__schema.types.filter((t) =>
    typeIsAbstract(t)
  ) as Array<IntrospectionAbstractType>;
  // eslint-disable-next-line benchlint/no-spread-reduce
  return abstractTypes.reduce(
    (memo, typeDef) => ({
      ...memo,
      [typeDef.name]: (typeDef.possibleTypes || []).map((possibleType) => possibleType.name),
    }),
    {}
  );
}

export const getPossibleTypesMappingForSchema = lazyInit(() =>
  PossibleTypesMapping.create(getTypenameToPossibleTypesFromSchema())
);
